module.exports = __webpack_public_path__ + "img/40.8d8684c9.jpg";